import { CHANGE_MENUE } from "../Actions/ActionTypes"
  
  const ChangeMenueReducer = (state =false, action) => {
    switch (action.type) {
      case CHANGE_MENUE:
        return action.payload 
      default:
        return state
    }
  }
  export default ChangeMenueReducer

  